import db from "../driverappdb"

export const ProjectTypeRepository = {
    getAllProjectTypes: async () => await db.projecttypes.toArray(),
    getProjectType: async (projectTypeId) => await db.projecttypes.get(projectTypeId),
    getProjectTypes: async (projectTypeIds) => {
        return await db.projecttypes.bulkGet(projectTypeIds);
    }
}